var selectioCtrlDesk = document.querySelector(".store-selection-ctrl"),
  selectionListDesk = document.querySelector(".store-selection-list"),
  selectionListItemsDesk = document.querySelectorAll(".store-selection-list-item"),
  storeNameDesk = document.querySelector("#store--name"),
  storeSelectionButtonDesk = document.querySelector(
    ".store-selection-popup--button"
  ),
  storeURL = "self",
  visitingFrom = "UK",
  visitingCur = "GBP",
  modalClose = document.querySelector(".store-selection-popup--close"),
  flagClass = "";
 
var storeChecked = localStorage.getItem("storeChecked");
var urlParam = location.search.indexOf("redirectFrom");
if (storeChecked || urlParam != -1) {
  document.querySelector(".store-selecetion-popup").style.display = "none";
} 
// if (urlParam != -1) {
//   var queryString = window.location.search;
//   var urlParams = new URLSearchParams(queryString);
//   let store = urlParams.get("redirectFrom");
//   store = store.replace("%20", "");
//   localStorage.setItem("visitingFrom", store);
//   localStorage.setItem("storeChecked", "true");
// }

function showVisitingFrom() {
  var text = localStorage.getItem("visitingFrom");
  console.log(text);
  if (text != null) {
  const currentCountries = document.querySelectorAll(".visiting-from--text .current-country");
  const storeCountries = document.querySelectorAll(".store-country");
  const allCountryClasses = ["au", "gbp", "nz", "int", "usd", "sgd", "euro", "europe"];

  currentCountries.forEach(el => {
    allCountryClasses.forEach(cls => el.classList.remove(cls));
  });
  storeCountries.forEach(el => {
   allCountryClasses.forEach(cls => el.classList.remove(cls));
  });

  switch (text.trim()) {
    case "Australia":
      currentCountries.forEach(el => {
        el.classList.add("au");
        el.innerText = "AUS";
      });
      storeCountries.forEach(el => {
        el.classList.add("au");
        el.innerText = "Australia";
      });
      $(".store-selection-list-item.au").hide();
      visitingCur = "AUD";
      storeSelectionButtonDesk.innerText = `Go to Australia`;
      storeNameDesk.classList.add("store--name", "au");
      visitingFrom = "Australia";
      break;

    case "United Kingdom":
      currentCountries.forEach(el => {
        el.classList.add("gbp");
        el.innerText = "UK";
      });
      storeCountries.forEach(el => {
        el.classList.add("gbp");
        el.innerText = "United Kingdom";
      });
      $(".store-selection-list-item.gbp").hide();
      visitingCur = "GBP";
      $(".countrynameselect").html("United Kingdom");
      storeNameDesk.classList.add("store--name", "gbp");
      visitingFrom = "United Kingdom";
      break;

    case "New Zealand":
      currentCountries.forEach(el => {
        el.classList.add("nz");
        el.innerText = "NZ";
      });
      storeCountries.forEach(el => {
        el.classList.add("nz");
        el.innerText = "New Zealand";
      });
      $(".store-selection-list-item.nz").hide();
      visitingCur = "NZD";
      storeSelectionButtonDesk.innerText = `Go to New Zealand`;
      storeNameDesk.classList.add("store--name", "nz");
      visitingFrom = "New Zealand";
      break;

    case "International":
      currentCountries.forEach(el => {
        el.classList.add("int");
        el.innerText = "INT";
      });
      storeCountries.forEach(el => {
        el.classList.add("int");
        el.innerText = "International";
      });
      $(".store-selection-list-item.int").hide();
      visitingCur = "USD";
      storeNameDesk.classList.add("store--name", "int");
      visitingFrom = "International";
      break;

    case "United States":
      currentCountries.forEach(el => {
        el.classList.add("usd");
        el.innerText = "USA";
      });
      storeCountries.forEach(el => {
        el.classList.add("usd");
        el.innerText = "United States";
      });
      $(".store-selection-list-item.us").hide();
      visitingCur = "USD";
      storeNameDesk.classList.add("store--name", "usa");
      visitingFrom = "United States";
      break;
 

    case "The Netherlands":
      currentCountries.forEach(el => {
        el.classList.add("euro");
        el.innerText = "NL";
      });
      storeCountries.forEach(el => {
        el.classList.add("euro");
        el.innerText = "Netherlands";
      });
      $(".store-selection-list-item.euro").hide();
      visitingCur = "EUR";
      storeSelectionButtonDesk.innerText = `Go to Netherlands`;
      storeNameDesk.classList.add("store--name", "euro");
      visitingFrom = "Netherlands";
      break;
    case "Netherlands":
      currentCountries.forEach(el => {
        el.classList.add("euro");
        el.innerText = "NL";
      });
      storeCountries.forEach(el => {
        el.classList.add("euro");
        el.innerText = "Netherlands";
      });
      $(".store-selection-list-item.euro").hide();
      visitingCur = "EUR";
      storeSelectionButtonDesk.innerText = `Go to Netherlands`;
      storeNameDesk.classList.add("store--name", "euro");
      visitingFrom = "Netherlands";
      break;  

    case "Europe":
      currentCountries.forEach(el => {
        el.classList.add("europe");
        el.innerText = "EU";
      });
      storeCountries.forEach(el => {
        el.classList.add("europe");
        el.innerText = "Europe";
      });
      $(".store-selection-list-item.europe").hide();
      visitingCur = "EUR";
      storeNameDesk.classList.add("store--name", "europe");
      visitingFrom = "Europe";
      break;
  }
} else {
    document
      .querySelectorAll(
        ".store-selecetion-popup .visiting-from--text .current-country"
      )
      .forEach(function (el) {
        el.classList.add("uk");
      });
    document
      .querySelectorAll(
        ".store-selecetion-popup .visiting-from--text .current-country"
      )
      .forEach(function (el) {
        el.innerText = "UK";
      });
    document
      .querySelectorAll(".store-selecetion-popup .store-country")
      .forEach(function (el) {
        el.classList.add("uk");
      });
    document
      .querySelectorAll(".store-selecetion-popup .store-country")
      .forEach(function (el) {
        el.innerText = "United Kingdom";
      });
    $(".store-selecetion-popup .store-selection-list-item.au").hide();
    visitingCur = "GBP";
    storeNameDesk.classList.add("store--name", "uk");
    visitingFrom = "United Kingdom";
  }
}



function rebuildSelectionListDesk(current) {
  selectionListItemsDesk.forEach(function (el) {
    if (current == el) {
      el.style.display = "none";
    } else {
      el.style.display = "block";
    }
  });
}

function showSelectionPopup() {
  document.querySelector(".store-selecetion-popup").style.display = "flex";
}
selectioCtrlDesk.addEventListener("click", function () {
  if (selectionListDesk.classList.contains("is-open")) {
    selectionListDesk.classList.remove("is-open");
  } else {
    selectionListDesk.classList.add("is-open");
  }
});

selectionListItemsDesk.forEach(function (item) {
  item.addEventListener("click", function () {
    storeURL = item.getAttribute("data-link");
    selectionListDesk.classList.remove("is-open");
    storeNameDesk.classList = "";
    flagClass = item.classList[1];
    storeNameDesk.innerText = item.innerText;
    storeNameDesk.classList.add("store--name", flagClass);
    visitingFrom = item.innerText;
    console.log(visitingFrom)
    visitingCur = item.getAttribute("data-currency");
    storeSelectionButtonDesk.innerText = `Go to ${item.innerText}`;
    rebuildSelectionListDesk(item);
    console.log(flagClass +'==>'+ visitingCur)
  });
});

storeSelectionButtonDesk.addEventListener("click", function () {
  if (storeURL == "self") {
    document.querySelector(".store-selecetion-popup").style.display = "none";
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    showVisitingFrom();
  } else {
    window.location.href = `${storeURL}?redirectFrom=${visitingFrom}`;
  }

  
  if(visitingCur == 'AUD' || visitingCur == 'NZD'){
   console.log(visitingCur) 
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://bhumi.com.au/?redirectFrom=${visitingFrom}`;
  }else if(visitingCur == 'USD' || visitingCur == 'INT' || visitingCur == 'SGD'){
    console.log(visitingCur) 
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://bhumiorganic.com/?redirectFrom=${visitingFrom}`;
  }else{
    document.querySelector(".store-selecetion-popup").style.display = "none";
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    $(".currency-selector-auto select").val(visitingCur);
    $(".currency-selector-auto form").submit();
  }
});

modalClose.addEventListener("click", function () {
  localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", "United Kingdom");
  document.querySelector(".store-selecetion-popup").style.display = "none";
});
document.addEventListener('showVisitingFrom', () => {
    showVisitingFrom();
});


